import { Box, Button, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import { OrderType } from "models/order_type";
import formatNumber from "views/admin/order/hooks/formatNumber";
import ItemTable from "./ItemTable";
import OrderProductItemTable from "./OrderProductTable";

interface IOrderItems {
  accountSelected: OrderType;
  itensAprovados: boolean;
  approve: (type: string) => void;
  reprove: (type: string) => void;
}
const OrderItems = ({
  accountSelected,
  approve,
  reprove,
  itensAprovados,
}: IOrderItems) => {

  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  return (
    <>
      <Box mb={"48px"}>
        <Box mb={"32px"} flexDirection={"row"}>
          <Stack direction={["column", "row"]} spacing="24px">
            <Text
              textAlign="left"
              color={"#422AFB"}
              fontWeight={"bold"}
              fontSize={24}
              w={"auto"}
              mt={4}
            >
              Revisão dos Itens de Orçamento :
            </Text>
            {itensAprovados ? (
              <Text color={"green"} fontWeight={"bold"} mt={6}>
                Itens Aprovados
              </Text>
            ) : (
              <Text color={"red"} fontWeight={"bold"} mt={6}>
                Itens em revisão
              </Text>
            )}
          </Stack>
          <Button
            colorScheme="red"
            variant="solid"
            float={"right"}
            mt={-12}
            onClick={() => {
              reprove("2");
            }}
          >
            REVISAR
          </Button>
          <Button
            colorScheme="green"
            variant="solid"
            float={"right"}
            mt={-12}
            mr={108}
            onClick={() => {
              approve("2");
            }}
          >
            APROVAR
          </Button>
        </Box>{" "}
      </Box>
      {accountSelected?.OrcamentoCategoria.map((item, index) => (
        <>
          <Text
            textAlign="left"
            color={"#422AFB"}
            fontWeight={"bold"}
            fontSize={28}
          >
            {index + 1} - {item.descricao} - subtotal :{" "}
            {formatNumber(Number(item.valor))}
          </Text>
          <Text
            textAlign="left"
            color={"#422AFB"}
            fontWeight={"bold"}
            mt={20}
            fontSize={20}
          >
            SERVIÇOS
          </Text>
          <ItemTable index={index} item1={item} />

          <Text
            textAlign="left"
            color={"#422AFB"}
            fontWeight={"bold"}
            mt={20}
            fontSize={20}
          >
            PRODUTOS
          </Text>
          <OrderProductItemTable
           borderColor={borderColor}
           categ={item}


          />
        </>
      ))}
    </>
  );
};
export default OrderItems;
